/* eslint-disable */
import { FuseNavigationItem } from "@fuse/components/navigation";
import { AuthSignInComponent } from "app/modules/auth/sign-in/sign-in.component";

// Assuming signInData.decodedToken has a structure like: { permissions: ["Role_Management", "User_Management"] }
const signInData = new AuthSignInComponent(null, null, null, null, null, null, null);
export const permissions = signInData.getToken();

const navigation = [
  {
    id: "role",
    title: "Role Management",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/role",
    permission: "Role_Management",
  },
  {
    id: "user",
    title: "User Management",
    type: "basic",
    icon: "heroicons_outline:user",
    link: "/user",
    permission: "User_Management",
  },
  {
    id: "question-bank",
    title: "Question Bank",
    type: "collapsable",
    icon: "heroicons_outline:question-mark-circle",
    link: "/question-bank",
    permission: "Question_Bank",
    children: [
      {
        id: "questionnaire-list",
        title: "questionnaire List",
        type: "basic",
        icon: "",
        link: "/question-bank/questionnaire-list",
        permission: "questionnaire List",
      },
    ],
  },
  {
    id: "workflow",
    title: "Workflow",
    type: "collapsable",
    icon: "heroicons_outline:question-mark-circle",
    link: "/workflow",
    permission: "Workflow",
    children: [
      {
        id: "active",
        title: "Active",
        type: "basic",
        icon: "",
        link: "/workflow",
        permission: "Workflow",
      },
    ],
  },
  {
    id: "vendor-inventory",
    title: "Vendor Inventory",
    type: "basic",
    icon: "heroicons_outline:arrow-up-right",
    link: "/vendor-inventory",
    permission: "Vendor Inventory",
  },
  {
    id: "risk-tiering",
    title: "Risk Tiering",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/risk-tiering",
    permission: "Risk Tiering",
  },
  {
    id: "assessment",
    title: "Assessment",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/assessment",
    permission: "Assessment",
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: "example",
    title: "Example",
    type: "basic",
    icon: "heroicons_outline:chart-pie",
    link: "/example",
  },
];
